import React, { useState, useEffect } from "react";
import Utility from "./Utility/Utility";
import Pages from "./Pages/Pages";
import VariableMap from "./VariableMap/VariableMap";
import { AuthContext } from "@/auth/AuthContext";
import { useContext } from "react";
import Option from "./Option/Option";

const PanelVariable = () => {
  const [activeComponent, setActiveComponent] = useState("Variable List");
  const {user} = useContext(AuthContext);
  const [editable, setEditable] = useState(null);

    useEffect(()=>{
      if(user?.roleId==1 || user?.roleId==2){
        setEditable(true)
      }
    },[user])
    
  const tabs = [
    { name: "Variable List", component: <VariableMap editable={editable} /> },
    { name: "Option List", component: <Option editable={editable} /> },
    { name: "Pages", component: <Pages editable={editable} /> },
    { name: "Utility", component: <Utility editable={editable} /> },
  ];

  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]">
      <h1 className="text-xl m-4 font-semibold">Panel Variable</h1>
      <div className="flex space-x-4 mb-6 max-w-100 flex-wrap">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`px-4 py-2 rounded-lg text-sm border-b-2 ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {setActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default PanelVariable;
